import ClampedText from 'react-dotdotdot';
import { Component } from 'react';
import PropTypes from 'prop-types';
import EventListener from 'react-event-listener';

export default class ClampText extends Component {
  static propTypes = {
    clamp: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    truncationHTML: PropTypes.string,
    useNativeClamp: PropTypes.bool,
  };

  state = {
    clampedTextKey: 0,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.clamp !== this.props.clamp) {
      this.handleResize();
    }
  }

  handleResize = () => {
    // Alternate the clamped text key here so that ClampedText re-renders
    // the text and truncates it correctly while the window size is increasing.
    this.setState({ clampedTextKey: this.state.clampedTextKey ? 0 : 1 });
  };

  render() {
    return (
      <EventListener
        target="window"
        onResize={this.handleResize}
        onLoad={this.handleResize}
      >
        <ClampedText
          clamp={this.props.clamp}
          className={this.props.className}
          truncationHTML={this.props.truncationHTML}
          useNativeClamp={this.props.useNativeClamp}
          key={this.state.clampedTextKey}
        >
          {this.props.children}
        </ClampedText>
      </EventListener>
    );
  }
}
